import { render, staticRenderFns } from "./CarReviews.vue?vue&type=template&id=091589fe&scoped=true"
import script from "./CarReviews.vue?vue&type=script&lang=js"
export * from "./CarReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091589fe",
  null
  
)

export default component.exports